import React from 'react';

import { observer } from 'mobx-react';

import { SubmissionVersionType } from 'utils/api/modules/entities/entities.types';

import { VERSION_HISTORY_LABEL } from './constants';
import { formatWindow, describeSource } from './formatters';
import {
  EarlierVersionContainer,
  EarlierVersionHeading,
  EarlierVersionDetail,
  BarActions,
  InlineButton,
  LinkButton,
} from './styles';

const label = (entry: SubmissionVersionType): string =>
  entry.isFirst ? `Version ${entry.version} (first)` : `Version ${entry.version}`;

const EarlierVersionBar: React.FC<{
  entry: SubmissionVersionType;
  onOpen: () => void;
  onReturnToLatest: () => void;
}> = ({ entry, onOpen, onReturnToLatest }): React.ReactElement => (
  <EarlierVersionContainer role="status" aria-live="polite" data-testid="submission-earlier-version-bar">
    <div>
      <EarlierVersionHeading data-testid="submission-earlier-version-heading">
        {`${label(entry)}. This is not the latest version.`}
      </EarlierVersionHeading>
      <EarlierVersionDetail data-testid="submission-earlier-version-detail">
        {`${formatWindow(entry)}. ${describeSource(entry)}.`}
      </EarlierVersionDetail>
    </div>
    <BarActions>
      <LinkButton variant="text" onClick={onOpen} data-testid="submission-version-history-open">
        {VERSION_HISTORY_LABEL}
      </LinkButton>
      <InlineButton variant="outlined" onClick={onReturnToLatest} data-testid="submission-return-to-latest">
        Return to latest
      </InlineButton>
    </BarActions>
  </EarlierVersionContainer>
);

export default observer(EarlierVersionBar);
